import { CountlyService } from './countly.service';
import {
  IAnalyticsConfiguration,
  IAnalyticsService
} from './ianalytics.interface';
import { SessionService } from '../session.service';

export class AnalyticsFactory {
  constructor(private sessionService: SessionService) {}
  // tslint:disable-next-line:variable-name
  public static Type = { Countly: 1, Clevertap: 2, Other: 0 };
  public createService(
    analitycServiceType,
    configuration: IAnalyticsConfiguration
  ): IAnalyticsService {
    switch (analitycServiceType) {
      case AnalyticsFactory.Type.Countly:
        const service = new CountlyService(this.sessionService);
        service.startService(configuration.url, configuration.key);
        return service;
      case AnalyticsFactory.Type.Clevertap:
        return null;
      case AnalyticsFactory.Type.Other:
        return null;
      default:
        return null;
    }
  }
}
